import { render, staticRenderFns } from "./ProductDefine.vue?vue&type=template&id=54710088&scoped=true&"
import script from "./ProductDefine.vue?vue&type=script&lang=js&"
export * from "./ProductDefine.vue?vue&type=script&lang=js&"
import style0 from "./ProductDefine.vue?vue&type=style&index=0&id=54710088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54710088",
  null
  
)

export default component.exports